export default "__VITE_ASSET__CbPMYYfB__"